import { api } from "./restUtil";
import { apiQuery } from "utils/queries";

type StandardPingResponse = {
  user: {
    id: string;
  } | null;
  ping: "pong";
};

type AdminPingResponse = {
  user: {
    id: string | null;
  };
  premier_status: "pong";
  python: {
    long_version: string;
    version: string;
  };
  orm: {
    alembic: {
      version: string;
    };
    name: string;
    driver: string;
    version: string;
    schema: string;
  };
  version: string;
  host: {
    system: string;
    node: string;
    release: string;
    version: string;
    machine: string;
    processor: string;
  };
};

export type PingResponse = StandardPingResponse | AdminPingResponse;

export function fetchPing() {
  return api.get<PingResponse>("/ping");
}

export const pingQuery = apiQuery<PingResponse>({ key: "/ping" });
